import request from "./promise/request";

export function getShareConfig(data) {
    return request.post(
        'https://testapi.xmy.club/weapi/user/get_jssdk_sign',
        data
    );
}
// export function getShareConfig(data) {
//     return request.post(
//         'api/user/get_jssdk_sign',
//         data
//     );
// }